import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Accounting.module.css';
import { CheckSmall } from '../../icons';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const Header = () => (
  <header className={styles.hero}>
    <div className={`${styles.container} ${styles.heroGrid}`}>
      <div>
        <div className={`${styles.breadcrumb} ${styles.reveal} ${styles.d1}`}>
          <Link to="/">Fyntiq Business</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <Link to="/#features">Features</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <span className={styles.breadcrumbCur}>Accounting</span>
        </div>
        <h1 className={`${styles.reveal} ${styles.d2}`}>
          Books that<br /><span className={styles.hl}>keep themselves.</span>
        </h1>
        <p className={`${styles.heroSub} ${styles.reveal} ${styles.d3}`}>
          Track income and expenses in one place. Connect your bank, upload receipts, and let AI organize everything so you walk into tax season already sorted.
        </p>
        <div className={`${styles.heroCta} ${styles.reveal} ${styles.d4}`}>
          <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow}>Get started free</Link>
          <a href="#how" className={styles.btnOutlineHero}>See how it works</a>
        </div>
        <div className={`${styles.heroNote} ${styles.reveal} ${styles.d5}`}>
          <span><CheckSmall />Auto-reconciled</span>
          <span><CheckSmall />Free to start</span>
          <span><CheckSmall />Export anytime</span>
        </div>
      </div>

      <div className={`${styles.heroVisual} ${styles.reveal} ${styles.d3}`}>
        <div className={`${styles.floatChip} ${styles.fcCash}`}>
          <div className={`${styles.fcIc} ${styles.fcIcY}`}>
            <svg viewBox="0 0 24 24" width="18" fill="none" stroke="#161614" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12a9 9 0 1 1-3-6.7M21 4v4h-4" />
            </svg>
          </div>
          <div><div className={styles.fcLab}>Reconciled</div><div className={styles.fcVal}>Auto</div></div>
        </div>
        <div className={`${styles.floatChip} ${styles.fcPayout}`}>
          <div className={`${styles.fcIc} ${styles.fcIcG}`}><CheckSmall /></div>
          <div><div className={styles.fcLab}>Tax report</div><div className={styles.fcVal}>Ready</div></div>
        </div>

        <div className={styles.payCard}>
          <div className={styles.invTop}>
            <div><div className={styles.invLab}>INCOME</div><div className={styles.invNum}>April 2026</div></div>
            <span className={styles.invStatus} style={{ background: 'var(--green-soft)', color: 'var(--green)' }}>Reconciled</span>
          </div>
          <div className={styles.invRow}><span>Collected</span><span className={styles.mono}>$18,420.00</span></div>
          <div className={styles.invRow}><span>Outstanding</span><span className={styles.mono}>$3,480.00</span></div>
          <div className={styles.invRow}><span>Processing fees</span><span className={styles.mono}>$512.18</span></div>
          <div className={styles.invTotal}><span>Net income</span><span className={styles.mono}>$17,907.82</span></div>
          <div className={styles.invPaynow}>Export report →</div>
        </div>
      </div>
    </div>
  </header>
);

export default Header;
